import InputFactory from "../../../../../components/InputFactory";
import BaseFormPage from "../../../../../base/BaseFormPage";
import Divider from "../../../../../components/common/Divider";
import AdditionalInfoTable from "./AdditionalInfoTable";
import EmployeeFormPresenter from "../../employee-form/EmployeeFormPresenter";

export default class AdditionalInfo extends BaseFormPage {
  constructor(props) {
    super(props);
    this.presenter = new EmployeeFormPresenter(this);
    this.state = {
      questionOne: false,
      questionTwo: false,
      questionThree: false,
      questionFour: false,
      questionFive: false,
      questionSix: false,
      questionSeven: false,
      questionEight: false,
      questionNine: false,
      questionTen: false,
      questionEleven: false,
      questionTwelve: false,
    };
  }

  hasValue = (value) => {
    if (value === null || value === undefined) return false;
    if (typeof value === "string") return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    if (value instanceof Date) return !Number.isNaN(value.getTime());
    if (typeof value === "object") return Object.keys(value).length > 0;
    return true;
  };

  getCollectionName() {
    return "employees";
  }
  componentDidMount() {
    this.presenter.componentDidMount();
    const obj = this.props.object || {};
    const keys = [
      "questionOne",
      "questionTwo",
      "questionThree",
      "questionFive",
      "questionSix",
      "questionSeven",
      "questionEight",
      "questionNine",
      "questionTen",
      "questionEleven",
      "questionTwelve",
    ];
    const updatedState = keys.reduce((acc, k) => {
      if (this.hasValue(obj?.[k])) acc[k] = true;
      return acc;
    }, {});

    if (
      this.hasValue(obj?.questionFour) ||
      this.hasValue(obj?.questionFourDate) ||
      this.hasValue(obj?.questionFourStat)
    ) {
      updatedState.questionFour = true;
    }

    this.setState(updatedState);
  }
  handleToggleState = (key) => {
    this.setState((prevState) => ({ [key]: !prevState[key] }));
  };

  toggleItemChildList = (question, fieldState, field, object, options = {}) =>
    this.presenter.toggleItemChildList(question, fieldState, field, object, options);

  toggleItemParentList = (question, fieldState, field, object, options = {}) =>
    this.presenter.toggleItemParentList(question, fieldState, field, object, options);
  render() {
    const { object } = this.props;
    const qDefs = [
      { kind: "child", key: "questionOne", label: "A. within the third degree?" },
      {
        kind: "child",
        key: "questionTwo",
        label:
          "B. within the fourth degree (for Local Government Unit - Career Employees)?",
      },
      {
        kind: "parent",
        key: "questionThree",
        label: "A. Have you ever been found guilty of any administrative offense?",
      },
      {
        kind: "parent",
        key: "questionFive",
        label:
          "Have you even been convicted of any crime or violation of any law, decree, ordinance or regulation by any court of tribunal?",
      },
      {
        kind: "parent",
        key: "questionTwelve",
        label:
          "Have you even been separated from the service in any of the following modes: resignation, retirement, dropped from the rolls, dismissal, termination, end of term, finished contract or phased out (abolition) in the public or private sector?",
      },
      {
        kind: "parent",
        key: "questionSix",
        label:
          "A. Have you ever been a candidate in a national or local election held within the last year (except Barangay election)?",
      },
      {
        kind: "parent",
        key: "questionSeven",
        label:
          "B. Have you resigned from the government service during the three (3)-month period before the last election to promote/actively campaign for a national or local candidate?",
      },
      {
        kind: "parent",
        key: "questionEight",
        label:
          "Have you acquired the status of an immigrant or permanent resident of another country?",
      },
      {
        kind: "child",
        key: "questionNine",
        label: "a. Are you a member of any idigenous group?",
      },
      {
        kind: "child",
        key: "questionTen",
        label: "b. Are you a person with disability?",
      },
      { kind: "child", key: "questionEleven", label: "c. Are you a solo parent?" },
    ];

    return (
      <>
        <Divider title={"Additional Information"} />
        <ul
          className="row"
          style={{
            fontFamily:
              '-apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
            fontSize: "14px",
          }}
        >
          <li style={{ fontWeight: 600 }}>
            Are you related by consanguinity or affinity to the appointing or
            recommending authority, or to the chief of bureau of office or the
            person who has immediate supervision over you in the Office, Bureau
            or Department where you will be appointed,
          </li>
          <div className="row mt-1">
            {qDefs.slice(0, 3).map((q) =>
              q.kind === "child"
                ? this.toggleItemChildList(q.label, this.state[q.key], q.key, object)
                : this.toggleItemParentList(q.label, this.state[q.key], q.key, object),
            )}

            <li>
              <div className="row">
                <p className="col-lg-6 d-flex align-items-center mt-2">
                  B. Have you been criminally charge before any court?
                </p>
                <button
                  type="button"
                  className="btn col-lg-3 w-auto p-0 me-5 border-0 bg-transparent shadow-none"
                  onClick={() => this.handleToggleState("questionFour")}
                >
                  <i
                    className={`text-center ${
                      this.state.questionFour
                        ? "bi bi-toggle-on"
                        : "bi bi-toggle-off"
                    }`}
                    style={{ zoom: 1.5, padding: 0 }}
                  ></i>
                </button>
                <div
                  className={`col-lg-5 ${
                    this.state.questionFour ? "" : "d-none"
                  } d-flex align-items-center`}
                >
                  <InputFactory
                    uppercase
                    placeholder="Please give details"
                    type="String"
                    object={object}
                    field="questionFour"
                    onChange={this.onChange.bind(this)}
                  />
                  <InputFactory
                    uppercase
                    placeholder="Please give details"
                    type="Date"
                    object={object}
                    field="questionFourDate"
                    onChange={this.onChange.bind(this)}
                  />
                  <InputFactory
                    uppercase
                    placeholder="Status of Case/s"
                    type="String"
                    object={object}
                    field="questionFourStat"
                    onChange={this.onChange.bind(this)}
                  />
                </div>
              </div>
            </li>

            {qDefs.slice(3, 8).map((q) =>
              this.toggleItemParentList(q.label, this.state[q.key], q.key, object),
            )}

            <li style={{ fontWeight: 600 }}>
              Pursuant to: (a) Indigenous People’s Act (RA 8371); (b) Magna
              Carta for Disabled Persons (RA 7277); and (c) Solo Parents Welfare
              Act of 2000 (RA 8971), please answer the following items:
            </li>

            {qDefs.slice(8).map((q) =>
              this.toggleItemChildList(q.label, this.state[q.key], q.key, object),
            )}
          </div>
        </ul>

        <Divider title={"References"} />

        <AdditionalInfoTable object={object} />

        <hr />

        <span
          style={{
            fontSize: "14px",
            color: "rgba(0, 0, 0, .65)",
            fontStyle: "italic",
          }}
        >
          Government Issued ID (i.e.Passport, GSIS, SSS, PRC, Driver's License,
          etc.)
          <p>PLEASE INDICATE ID Number and Date of Issuance</p>
        </span>

        <div className="row">
          <div className="col-lg-4">
            <label style={{ fontSize: "14px", paddingBottom: "10px" }}>
              Government Issued ID
            </label>
            <InputFactory
              uppercase
              type="String"
              placeholder={"Government Issued ID"}
              field="government11"
              object={object}
              onChange={this.onChange.bind(this)}
            />
          </div>
          <div className="col-lg-4">
            <label style={{ fontSize: "14px", paddingBottom: "10px" }}>
              ID\License\Passport No.
            </label>
            <InputFactory
              uppercase
              type="String"
              field="passport11"
              object={object}
              placeholder={"Government Issued ID"}
              onChange={this.onChange.bind(this)}
            />
          </div>
          <div className="col-lg-4">
            <label style={{ fontSize: "14px", paddingBottom: "10px" }}>
              Date\Place of Issuance
            </label>
            <InputFactory
              uppercase
              type="String"
              field="issurance11"
              object={object}
              placeholder={"Date or Place of Issurance"}
              onChange={this.onChange.bind(this)}
            />
          </div>
        </div>

        <div className="mt-4 d-flex justify-content-end">
          <div className="border" style={{ borderRadius: "4px" }}>
            <button
              style={{
                borderRadius: "4px 0 0 4px",
                backgroundColor: "#29457c",
              }}
              disabled={this.props.isSubmitting}
              onClick={() => {
                if (this.props.isSubmitting) return;
                (this.props.presenter || this.presenter).showDialogSubmit(
                  this.props.object,
                );
              }}
              className="btn btn-primary fs-sm me-0"
            >
              {this.props.isSubmitting ? "Saving..." : "Submit"}
            </button>
            <button
              style={{ borderRadius: "0", backgroundColor: "#fff" }}
              type="button"
              className="btn btn-light fs-sm me-0"
              onClick={this.props.onClickPrev}
            >
              Previous
            </button>
            <button
              style={{
                borderRadius: " 0 4px 4px 0",
                backgroundColor: "#29457c",
              }}
              onClick={this.props.onChangeTab}
              className="btn btn-primary fs-sm me-0"
            >
              Next
            </button>
          </div>
        </div>
      </>
    );
  }
}
